import React from 'react';
import PropertyManagementAssignment from './PropertyManagementAssignment';
import AutoAssign from './AutoAssign';

export default function TeamAssignment({
  users = [],
  teamId = '',
  managerId = '',
  onAssignmentChange,
  selectClassName = '',
  cleaningAssignedUserId,
  inspectionAssignedUserId,
  walkthroughAssignedUserId,
  area,
  allUsers = [],
  onInputChange,
}) {
  return (
    <>
      <div className="px-4 py-5 sm:px-6 bg-gray-50 border-b border-gray-200">
        <h3 className="text-lg font-medium leading-6 text-gray-900">Team Assignment</h3>
        <p className="mt-1 text-sm text-gray-500">
          Assign property management and the people who should automatically receive jobs
        </p>
      </div>
      <div className="p-6 space-y-8">
        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">Property Management</label>
          <PropertyManagementAssignment
            users={users}
            teamId={teamId}
            managerId={managerId}
            selectClassName={selectClassName}
            onChange={onAssignmentChange}
          />
        </div>
        <div className="border-t border-gray-200 pt-8">
          <div className="mb-4">
            <h4 className="text-base font-medium text-gray-900">Auto-Assignment Settings</h4>
            <p className="mt-1 text-sm text-gray-500">
              Configure which users should be automatically assigned to jobs for this property
            </p>
          </div>
          <AutoAssign
            cleaningAssignedUserId={cleaningAssignedUserId}
            inspectionAssignedUserId={inspectionAssignedUserId}
            walkthroughAssignedUserId={walkthroughAssignedUserId}
            area={area}
            allUsers={allUsers}
            onInputChange={onInputChange}
            showHeader={false}
          />
        </div>
      </div>
    </>
  );
}
